module.exports = __webpack_public_path__ + "media/scholarships/owl-welcome-38ae3365.png";